import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import VistoeraBrandMark from '../../components/VistoeraBrandMark'
import { LEGAL_EFFECTIVE_DATE, LEGAL_LAST_UPDATED } from './metadata'
import PublicLegalFooter from './PublicLegalFooter'
import type { PublicLegalRouteKey } from '../routes'
import './public-legal.css'

interface Props {
  documentKey: PublicLegalRouteKey
}

export default function LegalDocumentPage({ documentKey }: Props) {
  const { t } = useTranslation('legal')
  const title = t(`documents.${documentKey}.title`)
  const sections = t(`documents.${documentKey}.sections`, { returnObjects: true }) as Array<{
    heading: string
    paragraphs: string[]
  }>

  useEffect(() => {
    document.title = `${title} | Vistoera`
  }, [title])

  return (
    <div className="pub-legal-page">
      <header className="pub-legal-header">
        <Link to="/" className="pub-legal-brand" aria-label={t('shell.brandHome')}>
          <VistoeraBrandMark />
          <span>Vistoera</span>
        </Link>
      </header>

      <main className="pub-legal-main">
        <article className="pub-legal-article">
          <h1>{title}</h1>
          <p className="pub-legal-meta">
            {t('shell.effectiveDateLabel')}: {LEGAL_EFFECTIVE_DATE} · {t('shell.lastUpdatedLabel')}: {LEGAL_LAST_UPDATED}
          </p>
          <p className="pub-legal-disclaimer">{t('shell.disclaimer')}</p>

          {Array.isArray(sections)
            ? sections.map((section) => (
                <section key={section.heading} className="pub-legal-section">
                  <h2>{section.heading}</h2>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph.slice(0, 48)}>{paragraph}</p>
                  ))}
                </section>
              ))
            : null}

          <p className="pub-legal-contact">
            {t('shell.contactLabel')}: <a href={`mailto:${t('shell.contactEmail')}`}>{t('shell.contactEmail')}</a>
          </p>
        </article>
      </main>

      <PublicLegalFooter />
    </div>
  )
}
